import { map } from 'lodash/fp';
import { CardTypeImage } from '../CardTypeImage';
import { ContainerElement } from './style';
import { CardTypeListProps } from './types';

export const CardTypeList: React.FC<CardTypeListProps> = ({ assetLoader, currentType, supportedTypes }) => (
    <ContainerElement>
        {map(
            (type) => (
                <CardTypeImage
                    assetLoader={assetLoader}
                    key={type}
                    type={type}
                    enabled={!currentType || type.toLowerCase() === currentType.toLowerCase()}
                />
            ),
            supportedTypes
        )}
    </ContainerElement>
);
